import template		from "./treeview-item-device.html";
import css			from "./treeview-item-device.css";

import {TreeView}	from "gui";
import {Tooltip}	from "gui";


class TreeviewItemDevice extends TreeView.Item {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-treeview-item-device", TreeviewItemDevice);
  }
  static get schema() {
    return({
      "description": "User defined Treeview Item",
      "type": "object",
      "properties": {}
    });
  }
  static get designer() {
    return({
      "category": "User Defined",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-button"}
    });
  }
  connectedCallback(...args) {
    super.connectedCallback(...args);

    this.appendChild( new Tooltip({
      value: `Name: ${this.__device.name}</br></br>usbProductName: ${this.__device.usbProductName}</br>usbSerialNumber: ${this.__device.usbSerialNumber}</br>`
    }) );
    
    this.label = this.__device[name];

  }
  constructor(p, device) {
    super(p);

    this.__device = device;

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));   
  }
  onupdatedevices_handler(event) {
    let devices = event.detail;
    let device = devices[this.__name];    

    if (device.errors && device.errors.length) {
      this.setAttribute("error", "");
    } else {
      this.removeAttribute("error");
    }

    if (device.warnings && device.warnings.length) {
      this.setAttribute("warning", "");
    } else {
      this.removeAttribute("warning");
    }
    
  }
  set name(value) {
    this.__name = value;
  }
  get name() {
    return this.__name;
  }
}

TreeviewItemDevice.constructor();

export default TreeviewItemDevice;